import React, { useEffect, useState, useRef } from 'react';
import $ from 'jquery';
import * as R from 'ramda';

import { PartnersHeader } from './header';
import { PartnersMainTable } from './table/index';
import { AddPartner } from './../_common/AddPartner';
import { ExportPartner } from './../_common/ExportPartner';
import { DeletePartnerModal } from './../_common/DeletePartner';
import { useHistory, useLocation } from 'react-router';
import { useDispatch } from 'react-redux';
import { GetPartners } from '../../../actions/backoffice/partners';
import { LoadingState } from '../../../_common/loadingState';
import * as Loadings from '../../../constants/loadings/backoffice/partners';


export const PartnersMain = ({ partners, isLoading, partnerState }) => {

	const dispatch = useDispatch();
	const searchQuery = useLocation();
	const history = useHistory();
	const pageQuery = new URLSearchParams(searchQuery.search);

	let page = pageQuery.get('page');
	let search = pageQuery.get('search');
	let sortBy = pageQuery.get('sortBy');
	let sortDesc = pageQuery.get('sortDesc');
	page = R.isNil(page) ? 1 : parseInt(page);
	search = R.isNil(search) ? "" : search;
	sortBy = R.isNil(sortBy) ? "name" : sortBy;
	sortDesc = R.isNil(sortDesc) ? "false" : sortDesc;

	const [selectedPartner, setSelectedPartner] = useState(undefined);
	const [pageSearch, setPageSearch] = useState(search);
	const renderRef = useRef(false);

	useEffect(() => {
		$('[data-toggle="tooltip"]').tooltip();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {

		if (isNaN(page) || page === 0) {
			history.push("backoffice/partners");
			return;
		}

		//pageNumber, searchTerm, sortByTerm, sortDesc
		dispatch(GetPartners(page, search, sortBy, sortDesc));

		// eslint-disable-next-line 
	}, [searchQuery.search, history.location]);

	let timer = null;
	useEffect(() => {

		if (!renderRef.current) {
			renderRef.current = true;
			return;
		};


		if (R.isEmpty(pageSearch)) {
			history.push(`/backoffice/partners?page=${1}${sortBy !== "" ? "&sortBy=" + sortBy : ""}${sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`);
			return;
		}

		clearTimeout(timer);
		timer = setTimeout(() => {
			dispatch(GetPartners(page, pageSearch, sortBy, sortDesc));
		}, 1000);


		return () => clearTimeout(timer);

		// eslint-disable-next-line 
	}, [pageSearch]);



	if ((R.isNil(partnerState.partners) || R.isEmpty(partnerState.partners)) && partnerState.isLoading.includes(Loadings.FETCHING_PARTNERS)) {
		return <LoadingState />;
	}

	if (R.isNil(partnerState.partners)) {
		return '';
	}

	const routerQuery = {
		page,
		search,
		sortBy,
		sortDesc,
	};

	return (
		<article className="view-calc pt-4 mb-auto pb-sm">
			<div className="container-fluid">
				<PartnersHeader partners={partners} partnerState={partnerState} />
			</div>
			<PartnersMainTable partners={partners} setSelectedPartner={setSelectedPartner} partnerState={partnerState} pageSearch={pageSearch} setPageSearch={setPageSearch} routerQuery={routerQuery} />
			<AddPartner isLoading={isLoading} />
			<ExportPartner isLoading={isLoading} partners={partners} selectedPartner={selectedPartner} />
			<DeletePartnerModal selectedPartner={selectedPartner} isLoading={isLoading} />
		</article>
	);
};